module.exports = __webpack_public_path__ + "static/media/Seychelles.04954e50.png";